import {Box, HStack, Text, VStack} from "@chakra-ui/react";
import {CheckIcon, XIcon} from "@heroicons/react/outline";
import React from "react";

export const PropertyStatusIndicator = ({title, description, isOk}: { title: string, description: string, isOk: boolean }) => {
  return <HStack marginY={"0"} alignItems={"start"} spacing={"2"}>
    <Box>
      {isOk ?
        <CheckIcon
          className={"h-4 w-4 inline text-white bg-green-700 opacity-80 rounded-xl"}/> :
        <XIcon
          className={"h-4 w-4 p-0.5 inline text-white bg-red-700 opacity-80 rounded-xl"}/>}
    </Box>
    <VStack alignItems={"start"} spacing={"0"}>
      <Text textColor={"black"} fontWeight={"medium"}>{title}</Text>
      <Text textColor={"gray.700"} maxW={"2xl"}>{description}</Text>
    </VStack>
  </HStack>
}